import type { FaireProductEntity } from "../../entity_types/product";

export const p_7b9az77bav: FaireProductEntity = {
  token: "p_7b9az77bav",
  type: "product",
  name: "Ionic Liquid Iodine",
  brandToken: "b_n34zp8ykn9",
  brandName: "Eidon Ionic Minerals",
  imageUrl:
    "https://cdn.faire.com/fastly/7c7cd1940350cf2de1eb4ba076fd2d4b9355922d7683b44db7d0a5b3258b3a84.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f03c9dc22718de5aa97e245f0dc4358a3c921f2b035208243432b3802cec51f.jpeg",
    "https://cdn.faire.com/fastly/5b0c4ef2ef71c237010e9be577fb441b7d4b83423acc69ce5ed9d5730667a136.jpeg",
  ],
  priceDollars: 13.85,
  description:
    "As the awareness and demand for iodine as thyroid protection quickly becomes more mainstream, stay calm with Eidon!\nWe manufacture a liquid iodine supplement perfectly suited for protection of not only the thyroid, but also the tissues of the breast, and prostate from the impact of radioactive iodine-131 absorption.\nEidon’s Iodine is made from Potassium Iodide (KI) salt derived from Iodine wells found near natural gas deposits. This is the raw material recommended by all health professionals for most if not all health and medicinal applications of Iodine. When your thyroid is replete with elemental iodine the radioactive iodine-131 will not be absorbed into this organ. Potassium Iodide (KI) works by blocking radioactive iodine from entering the thyroid.\n\nIodine can become depleted when one is exposed to heavy metals such as mercury, lead, cadmium, aluminum and bromide. \n\n• Safe and stable for all ages.\n• 1 drop of Eidon’s Iodine contains 75% of the US RDA\n• Adjustable dose by the drop",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:47.345Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
